const DOMAIN_CORRECTIONS: Readonly<Record<string, string>> = {
  'gamil.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmail.con': 'gmail.com',
  'hotmial.com': 'hotmail.com',
  'outlok.com': 'outlook.com',
  'icloud.con': 'icloud.com',
};

export function suggestEmailCorrection(email: string): string | null {
  const at = email.lastIndexOf('@');
  if (at <= 0) return null;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1).toLowerCase();
  const corrected = DOMAIN_CORRECTIONS[domain];
  return corrected ? `${local}@${corrected}` : null;
}
